import { HTMLAttributes } from 'react';
import styles from './HeaderTitle.module.scss';

interface HeaderTitleProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
}

const HeaderTitle = ({ title }: HeaderTitleProps) => <h2 className={styles.title}>{title}</h2>;

export default HeaderTitle;
